import { Circle } from 'src/api/circles';
import { Pagination } from 'src/api/common';
import api from './baseApi';

export interface Invoice {
  _id: string;
  createdAt: string;
  updatedAt: string;

  tribe: Circle;
  user_id: string;
  tribe_id: string;
  subscription_id: string;

  total_amount_usd: number;
  payment_status: string;
  paidAt: string;

  stripe_invoice_id: string;
  stripe_invoice_pdf?: string;
}

export interface GetInvoicesResponse {
  result: Invoice[];
  pagination: Pagination;
}

export const invoicesApi = {
  getInvoices: async (): Promise<GetInvoicesResponse> => {
    const axiosResponse = await api.get(`invoices`);
    return axiosResponse.data;
  },
};
